import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import React from "react";
import "./Comments.css";
import CommentCard from "./commentCard/CommentCard";
import type { ICommentCard } from "./commentCard/CommentCard";

const Comments = (props: CommentsProps) => {
    const { className, records } = props;

    return (
        <Box className={className}>
            <Stack className="comments-stack">
                {records?.map((commentRecord) => (
                    <CommentCard key={commentRecord.commentKey} {...commentRecord} />
                ))}
            </Stack>
        </Box>
    );
};

interface CommentsProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    records: ICommentCard[];
}

export default Comments;
